import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { Specification } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type SpecificationModel = getEntityType<SpecificationState>;

export type SpecificationState = EntityState<
  Omit<RequireSome<Partial<Specification>, 'id'>, 'settings'> & { settings: string[] }
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'specification' })
export class SpecificationStore extends EntityStore<SpecificationState> {
  constructor() {
    super({});
  }
}
